module.exports = __webpack_public_path__ + "img/2-text.5e548463.png";